import React, { useState } from "react";
import NormalLogin from "./NormalLogin";
import FaceSignup from "../FaceAuthentication/FaceSignup";
import FaceLogin from "../FaceAuthentication/FaceLogin";

const App = () => {
  const [activeTab, setActiveTab] = useState("normal");

  return (
    <div className="msh--main bg-img  signup-sec">
      <div className="d-flex justify-content-center ">
        <button
          className={`btn me-2 text-white`}
          style={{
            background: activeTab === "normal" ? "#fc7c37" : "#fd7a338f",
          }}
          onClick={() => setActiveTab("normal")}
        >
          Normal Login
        </button>
        <button
          className={`btn text-white `}
          style={{
            background: activeTab === "biometric" ? "#fc7c37" : "#fd7a338f",
          }}
          onClick={() => setActiveTab("biometric")}
        >
          Biometric Login
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === "normal" ? <NormalLogin /> : <FaceLogin />}
    </div>
  );
};

export default App;
